import { Component } from "react";
import { reportError } from "../lib/errorReport.js";

// Top-level error boundary. Its most important job: after a deploy, stale
// clients hold references to old hashed chunk files that no longer exist, so a
// route change throws a chunk-load error. We detect that case and offer a
// one-click reload (which picks up the new build) instead of a broken screen.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Boundary-caught render errors do not hit window.onerror; report directly.
    try {
      reportError(
        (error && error.name) || "RenderError",
        (error && error.message) || String(error),
        ((error && error.stack) || "") + "\n--- component stack ---" + ((info && info.componentStack) || "")
      );
    } catch (e) { /* ignore */ }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const msg = String((error && error.message) || error);
    const stale = /Loading chunk|dynamically imported module|Failed to fetch dynamically|import\(\)/i.test(msg);
    return (
      <div className="center-msg" style={{ flexDirection: "column", gap: 12, padding: 40, textAlign: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          {stale ? "MyTeslaApp was updated" : "Something went wrong"}
        </div>
        <div style={{ fontSize: 13, opacity: 0.7, maxWidth: 420 }}>
          {stale
            ? "A new version is available. Reload to get the latest."
            : "An unexpected error occurred. Reloading usually fixes it."}
        </div>
        <button
          type="button"
          className="au-btn au-btn--primary"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}
